<script setup lang="ts">
  defineOptions({ inheritAttrs: false })

  const model = defineModel<string>({ default: '' })

  const props = withDefaults(
    defineProps<{
      label: string
      required?: boolean
      placeholder?: string
      ui?: Record<string, unknown>
    }>(),
    {
      required: false,
      placeholder: '',
    },
  )

  defineSlots<{
    leading?: (props: { ui: unknown }) => unknown
    trailing?: (props: { ui: unknown }) => unknown
    label?: () => unknown
  }>()

  const attrs = useAttrs()

  const mergedUi = computed(() => {
    const u = { ...(props.ui ?? {}) }
    const existing = typeof u.base === 'string' ? u.base : ''
    u.base = [existing, 'peer'].filter(Boolean).join(' ')
    return u
  })

  const displayLabel = computed(() => (props.required ? `${props.label} *` : props.label))

  const FLOAT_LABEL_CLASS =
    'pointer-events-none absolute left-0 z-10 -top-2.5 text-highlighted text-xs font-medium px-1.5 transition-all peer-focus:-top-2.5 peer-focus:text-highlighted peer-focus:text-xs peer-focus:font-medium peer-placeholder-shown:text-sm peer-placeholder-shown:text-dimmed peer-placeholder-shown:top-1.5 peer-placeholder-shown:font-normal'
</script>

<template>
  <UInput
    v-model="model"
    :placeholder="placeholder"
    v-bind="attrs"
    :ui="mergedUi"
  >
    <label :class="FLOAT_LABEL_CLASS">
      <span class="inline-flex bg-default px-1">
        <slot name="label">{{ displayLabel }}</slot>
      </span>
    </label>
    <template v-if="$slots.leading" #leading="slotProps">
      <slot name="leading" v-bind="slotProps" />
    </template>
    <template v-if="$slots.trailing" #trailing="slotProps">
      <slot name="trailing" v-bind="slotProps" />
    </template>
  </UInput>
</template>
